// extracted by mini-css-extract-plugin
export default {"containerBlock":"NavigationDropDownStyles_containerBlock__zGjRN","signoutText":"NavigationDropDownStyles_signoutText__-enr-","profile":"NavigationDropDownStyles_profile__IC3hz"};